export default __webpack_public_path__ + "static/media/payoneer.14708c11.png";